import React, { useEffect } from "react";
import { Card, Button, Descriptions, Tag, Alert, Typography } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import { useLocation } from "react-router-dom";

const { Text } = Typography;

/**
 * Payment Success Page
 * Shown after successful payment completion
 */
const PaymentSuccess = () => {
  const location = useLocation();

  const params = new URLSearchParams(location.search);
  const paymentId = params.get("paymentId");
  const credits = params.get("credits");

  useEffect(() => {
    // Optional: Send analytics event
    console.log("Payment Success:", { paymentId, credits });
  }, [paymentId, credits]);

  const completionTime = new Date().toLocaleString();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f0f2f5",
        padding: "20px 16px",
      }}
    >
      <Card
        style={{ maxWidth: 550, width: "100%" }}
        bodyStyle={{ padding: "32px 24px" }}
      >
        <div style={{ textAlign: "center" }}>
          <CheckCircleOutlined style={{ fontSize: 56, color: "#52c41a" }} />
          <h2
            style={{
              fontSize: 24,
              fontWeight: 600,
              margin: "16px 0 8px",
              color: "#262626",
            }}
          >
            Payment Successful!
          </h2>
          <p style={{ fontSize: 14, color: "#595959", margin: 0 }}>
            Your payment has been processed and credits added to your wallet.
          </p>
        </div>

        <div style={{ margin: "24px 0" }}>
          <div
            style={{
              background: "#f6ffed",
              border: "1px solid #b7eb8f",
              borderRadius: 6,
              padding: "16px",
              marginBottom: 16,
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <span style={{ fontSize: 13, color: "#52c41a" }}>
                Credits Added
              </span>
              <span style={{ fontSize: 22, fontWeight: 600, color: "#52c41a" }}>
                {credits || ""}
              </span>
            </div>
          </div>

          <Descriptions
            column={1}
            size="small"
            bordered
            style={{ fontSize: 13 }}
          >
            <Descriptions.Item
              label="Transaction ID"
              labelStyle={{ width: 140, fontSize: 12 }}
              contentStyle={{ fontSize: 12 }}
            >
              <Text code style={{ fontSize: 11 }}>
                {paymentId || "N/A"}
              </Text>
            </Descriptions.Item>
            <Descriptions.Item
              label="Status"
              labelStyle={{ fontSize: 12 }}
              contentStyle={{ fontSize: 12 }}
            >
              <Tag color="success" style={{ fontSize: 11 }}>
                COMPLETED
              </Tag>
            </Descriptions.Item>
            <Descriptions.Item
              label="Payment Method"
              labelStyle={{ fontSize: 12 }}
              contentStyle={{ fontSize: 12 }}
            >
              <Text>ATOM Payment Gateway</Text>
            </Descriptions.Item>
            <Descriptions.Item
              label="Processed At"
              labelStyle={{ fontSize: 12 }}
              contentStyle={{ fontSize: 12 }}
            >
              <Text>{completionTime}</Text>
            </Descriptions.Item>
          </Descriptions>
        </div>

        <div style={{ marginTop: 24 }}>
          <Alert
            message="What's Next?"
            description={
              <div style={{ fontSize: 12 }}>
                <div>✓ Your wallet has been credited instantly</div>
                <div>✓ Invoice will be sent to your registered email</div>
                <div>✓ You can start using credits immediately</div>
              </div>
            }
            type="info"
            showIcon
            style={{ marginBottom: 16 }}
          />

          <Button
            type="primary"
            size="large"
            block
            onClick={() => {
              // Redirect to ERP WhatsApp Credits page
              const erpUrl =
                process.env.REACT_APP_ERP_URL || "http://localhost:3000";
              const redirectUrl = `${erpUrl}/default/adminmodule/whatsapp-credits`;

              if (window.opener) {
                // If opened in popup, post message to parent and redirect
                window.opener.postMessage(
                  {
                    type: "PAYMENT_SUCCESS",
                    paymentId: paymentId,
                    credits: credits,
                  },
                  "*",
                );
                window.opener.location.href = redirectUrl;
                window.close();
              } else {
                // Direct redirect
                window.location.href = redirectUrl;
              }
            }}
            style={{ height: 44, fontSize: 15, fontWeight: 500 }}
          >
            Return to Application
          </Button>

          <div style={{ textAlign: "center", marginTop: 12 }}>
            <Text type="secondary" style={{ fontSize: 12 }}>
              This window will close automatically or you can close it manually
            </Text>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default PaymentSuccess;
